import { createSelector } from '@reduxjs/toolkit';

import {
  // @ts-ignore lib types
  legalDataSelector,
  loggedSelector,
  userSelector,
} from '@lootboy/lib/selectors';
import { TUser } from '@lootboy/lib/types/user';

// checks if there is a legal data that a logged-in user have not consented to
export const isLegalDataUpdatedSelector = createSelector(
  [legalDataSelector, userSelector, loggedSelector],
  ({ _id }: { _id: string }, { consents = [] }: TUser, isLoggedIn: boolean) => {
    return isLoggedIn && !consents.some((consent) => consent.legalData === _id);
  },
);
